<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <v-toolbar-title
                ><h3 style="overflow-wrap: normal">
                    Controller
                </h3></v-toolbar-title
            >
        </v-toolbar>
        <v-row>
            <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="empresa_controller"
                    :items="empresas_controller"
                    item-text="nombre"
                    item-value="id"
                    label="Seleccionar empresa"
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="anio"
                    :items="anios"
                    label="Seleccionar año"
                >
                </v-autocomplete
            ></v-col>
        </v-row>

        <v-tabs v-model="tabs">
            <v-tab>Estadísticas</v-tab>
            <v-tab>Resumen</v-tab>
            <v-tab>Historial</v-tab>
            <v-tab>Cuentas contables</v-tab>
            <v-tab>Configuración</v-tab>
            <v-tab-item>
                <v-row style="margin-top: 10px">
                    <v-col cols="12" md="4">
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        PR {{ this.totales.totalPR }} €
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumen_pr"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        RECP Y ES SOBRE COSTE
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumenSobreCoste"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        ES {{ this.totales.totalES }} €
                                        {{ this.totales.porcentajeES }} %
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumen_es"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        RESUMEN FINAL
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :item-class="colorRow"
                                :headers="headers_resumen"
                                :items="resumen_total"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4"
                        v-if="this.empresa_controller == 1 && rol != 13"
                    >
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        CDK {{ this.totales.CDK }} €
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumen_total_cdk"
                                :hide-default-footer="true"
                                :item-class="colorRow"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4"
                        v-if="this.empresa_controller == 1 && rol != 13"
                    >
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        VALLAS {{ this.totales.VALLAS }} €
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumen_total_vallas"
                                :hide-default-footer="true"
                                :item-class="colorRow"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="this.empresa_controller == 1">
                    <v-col cols="12" md="4" v-if="rol != 13">
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        TRO {{ this.totales.totalTRO }} €
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :headers="headers_resumen"
                                :items="resumen_tro"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" v-if="rol != 13">
                        <v-card>
                            <v-toolbar flat color="#1d2735" dark>
                                <v-toolbar-title
                                    ><h3 style="overflow-wrap: normal">
                                        RESUMEN FINAL TRO
                                    </h3></v-toolbar-title
                                >
                            </v-toolbar>
                            <v-data-table
                                dense
                                :item-class="colorRow"
                                :headers="headers_resumen"
                                :items="resumen_total_tro"
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.total_sum="{ item }">
                                    <span>{{ item.total_sum }} €</span>
                                </template>
                                <template v-slot:item.porcentaje="{ item }">
                                    <span>{{ item.porcentaje }} %</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row style="margin-top: 10px">
                    <v-col cols="12" md="4">
                        <v-card style="text-align: center">
                            <h3 style="overflow-wrap: normal">
                                Objetivo de ventas
                            </h3>
                            {{ this.total_objetivo.total_vendido }} €
                        </v-card>

                        <speedometer
                            style="margin-top: 10px; margin-bottom: 10px"
                            :percent="total_resumen.porcentajeVenta"
                        >
                        </speedometer>
                        <v-col style="text-align: center">
                            {{ this.total_resumen.porcentajeVenta }} %
                        </v-col>
                        <v-col style="text-align: center">
                            {{ this.total_alcanzado.total_vendido }} €
                        </v-col>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card style="text-align: center">
                            <v-col style="text-align: center">
                                <h3>Facturación</h3>
                                <div
                                    :style="
                                        this.total_alcanzado
                                            .total_facturado[0] == '-'
                                            ? `color:red`
                                            : ''
                                    "
                                >
                                    {{ this.total_alcanzado.total_facturado }} €
                                </div>
                            </v-col>
                            <v-col style="text-align: center">
                                <h3>Beneficio</h3>
                                <div
                                    :style="
                                        this.total_resumen.beneficio[0] == '-'
                                            ? `color:red`
                                            : ''
                                    "
                                >
                                    {{ this.total_resumen.beneficio }} €
                                </div>
                            </v-col>
                            <v-col style="text-align: center">
                                <h3>Porcentaje</h3>
                                <div
                                    :style="
                                        this.total_resumen.porcentaje[0] == '-'
                                            ? `color:red`
                                            : ''
                                    "
                                >
                                    {{ this.total_resumen.porcentaje }} %
                                </div>
                            </v-col>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card style="text-align: center">
                            <h3>Objetivo de facturación</h3>
                            {{ this.total_objetivo.total_facturado }} €
                        </v-card>

                        <speedometer
                            style="margin-top: 10px; margin-bottom: 10px"
                            :percent="total_resumen.porcentajeFacturacion"
                        >
                        </speedometer>
                        <v-col style="text-align: center">
                            {{ this.total_resumen.porcentajeFacturacion }} %
                        </v-col>
                    </v-col>
                </v-row>
                <v-row>
                    <v-card style="margin: auto; width: 50%">
                        <v-row>
                            <v-col cols="12" md="6" style="text-align: center">
                                <v-col>
                                    <h3>Estructura presupuesto</h3>
                                </v-col>
                                <v-col>
                                    {{ this.total_presupuesto.epc }} %
                                </v-col>
                                <v-col>
                                    <h3>Estructura</h3>
                                </v-col>
                                <v-col>
                                    {{ this.total_resumen.estructura }} %
                                </v-col>
                            </v-col>
                            <v-col cols="12" md="6" style="text-align: center">
                                <v-col>
                                    <h3>RECP presupuesto</h3>
                                </v-col>
                                <v-col>
                                    {{ this.total_presupuesto.recp }} %
                                </v-col>
                                <v-col>
                                    <h3>RECP</h3>
                                </v-col>
                                <v-col> {{ this.total_resumen.recp }} % </v-col>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-col cols="12">
                    <apexchart
                        width="90%"
                        height="300"
                        type="line"
                        :options="chartOptions"
                        :series="series"
                    ></apexchart>
                </v-col>
                <v-col cols="12">
                    <apexchart
                        width="90%"
                        height="300"
                        type="line"
                        :options="chartOptions2"
                        :series="series_epc"
                    ></apexchart>
                </v-col>
                <v-data-table
                    :items="historial_cuentas"
                    :headers="historial_headers"
                >
                    <template v-slot:item.fecha="{ item }">
                        <span>{{ item.fecha | format_date }}</span>
                    </template>
                    <template v-slot:item.beneficio="{ item }">
                        <span>{{ item.beneficio }} €</span>
                    </template>
                    <template v-slot:item.porcentaje="{ item }">
                        <span>{{ item.porcentaje }} %</span>
                    </template>
                    <template v-slot:item.total_facturado="{ item }">
                        <span>{{ item.total_facturado }} €</span>
                    </template>
                    <template v-slot:item.estructura="{ item }">
                        <span>{{ item.estructura }} %</span>
                    </template>
                    <template v-slot:item.resto_estructura="{ item }">
                        <span>{{ item.resto_estructura }} %</span>
                    </template>
                    <template v-slot:item.diferencia_banco="{ item }">
                        <span>{{ item.diferencia_banco }} €</span>
                    </template>
                    <template v-slot:item.porcentaje_banco="{ item }">
                        <span>{{ item.porcentaje_banco }} %</span>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item>
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            color="orange darken-1"
                            class="mt-2"
                            @click="mostrarModalImportar"
                        >
                            <v-icon class="white--text">mdi-file-excel</v-icon>
                        </v-btn>
                    </template>
                    <span>Importar cuentas</span>
                </v-tooltip>
                <!--<v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            color="orange darken-1"
                            class="mt-2"
                            @click="mostrarModalTotalFacturado"
                        >
                            <v-icon class="white--text"
                                >mdi-currency-eur</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Total facturado</span>
                </v-tooltip>-->
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            color="orange darken-1"
                            class="mt-2"
                            @click="ExportExcel"
                        >
                            <v-icon class="white--text">mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <span>Total facturado</span>
                </v-tooltip>
                <v-row>
                    <v-col cols="12" md="4">
                        <FilterComponent
                            :headers="filter_headers"
                            v-model="filtros_prueba"
                        ></FilterComponent>
                    </v-col>
                </v-row>
                <v-data-table
                    @click:row="handleClick"
                    dense
                    v-model="selected"
                    show-select
                    :loading="loading"
                    :headers="headers"
                    :items="cuentasControllerFiltered"
                    :item-class="getRowClass"
                    :items-per-page="-1"
                    item-key="id"
                    :options.sync="options"
                    class="elevation-1"
                    :sort-by="['nombre']"
                    :sort-desc="[false]"
                >
                    <template v-slot:item.anterior="{ item }">
                        <span>{{ item.anterior }} €</span>
                    </template>
                    <template v-slot:item.total1="{ item }">
                        <span>{{ item.total1 }} €</span>
                    </template>
                    <template v-slot:item.total2="{ item }">
                        <span>{{ item.total2 }} €</span>
                    </template>
                    <template v-slot:item.total="{ item }">
                        <span>{{ item.total }} €</span>
                    </template>
                    <template v-slot:item.porcentaje="{ item }">
                        <span>{{ item.porcentaje }} %</span>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title
                                v-if="this.empresa_controller == 1"
                                class="text-h5 aviso"
                                style="
                                    justify-content: center;
                                    background: #1d2735;
                                    color: white;
                                "
                            >
                                {{ rol != 13 ? "" : "" }}
                            </v-card-title>
                            <v-card-title
                                v-if="this.empresa_controller != 1"
                                class="text-h5 aviso"
                                style="
                                    justify-content: center;
                                    background: #1d2735;
                                    color: white;
                                "
                            ></v-card-title>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_objetivo.total_facturado"
                                        :label="`Objetivo de facturación ${
                                            rol != 13 ? '' : ''
                                        }`"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzado.total_facturado
                                        "
                                        :label="`Total facturado ${
                                            rol != 13 ? '' : ''
                                        }`"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_objetivo.total_vendido"
                                        :label="`Objetivo ventas ${
                                            rol != 13 ? '' : ''
                                        }`"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_alcanzado.total_vendido"
                                        :label="`Total ventas ${
                                            rol != 13 ? '' : ''
                                        }`"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuesto.epc"
                                        :label="`Estructura presupuesto ${
                                            rol != 13 ? '' : ''
                                        }`"
                                        suffix="%"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuesto.recp"
                                        label="RECP presupuesto"
                                        suffix="%"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-card-actions class="pt-3">
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="error"
                                    large
                                    @click="dialog_toal_facturado = false"
                                    >Cancelar</v-btn
                                >
                                <v-btn
                                    color="success"
                                    large
                                    @click="saveTotalFacturado(1)"
                                    >Modificar</v-btn
                                >
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        v-if="this.empresa_controller == 1 && rol != 13"
                    >
                        <v-card>
                            <v-card-title
                                class="text-h5 aviso"
                                style="
                                    justify-content: center;
                                    background: #1d2735;
                                    color: white;
                                "
                            >
                                TRO
                            </v-card-title>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoTro.total_facturado
                                        "
                                        label="Objetivo de facturación TRO"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoTro.total_facturado
                                        "
                                        label="Total facturado TRO"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoTro.total_vendido
                                        "
                                        label="Objetivo ventas TRO"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoTro.total_vendido
                                        "
                                        label="Total ventas TRO"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoTro.epc"
                                        label="Estructura presupuesto TRO"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoTro.recp"
                                        label="RECP presupuesto"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-card-actions class="pt-3">
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="error"
                                    large
                                    @click="dialog_toal_facturado = false"
                                    >Cancelar</v-btn
                                >
                                <v-btn
                                    color="success"
                                    large
                                    @click="saveTotalFacturado(4)"
                                    >Modificar</v-btn
                                >
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="this.empresa_controller == 1 && rol != 13">
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title
                                class="text-h5 aviso"
                                style="
                                    justify-content: center;
                                    background: #1d2735;
                                    color: white;
                                "
                            >
                                CDK
                            </v-card-title>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoCdk.total_facturado
                                        "
                                        label="Objetivo de facturación CDK"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoCdk.total_facturado
                                        "
                                        label="Total facturado CDK"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoCdk.total_vendido
                                        "
                                        label="Objetivo ventas CDK"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoCdk.total_vendido
                                        "
                                        label="Total ventas CDK"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoCdk.epc"
                                        label="Estructura presupuesto CDK"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoCdk.recp"
                                        label="RECP presupuesto"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-card-actions class="pt-3">
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="error"
                                    large
                                    @click="dialog_toal_facturado = false"
                                    >Cancelar</v-btn
                                >
                                <v-btn
                                    color="success"
                                    large
                                    @click="saveTotalFacturado(2)"
                                    >Modificar</v-btn
                                >
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" v-if="rol != 13">
                        <v-card>
                            <v-card-title
                                class="text-h5 aviso"
                                style="
                                    justify-content: center;
                                    background: #1d2735;
                                    color: white;
                                "
                            >
                                VALLAS
                            </v-card-title>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoVallas.total_facturado
                                        "
                                        label="Objetivo de facturación Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoVallas.total_facturado
                                        "
                                        label="Total facturado Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_objetivoVallas.total_vendido
                                        "
                                        label="Objetivo ventas Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="
                                            total_alcanzadoVallas.total_vendido
                                        "
                                        label="Total ventas Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pa-3">
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoVallas.epc"
                                        label="Estructura presupuesto Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="total_presupuestoVallas.recp"
                                        label="RECP presupuesto Vallas"
                                        suffix="€"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-card-actions class="pt-3">
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="error"
                                    large
                                    @click="dialog_toal_facturado = false"
                                    >Cancelar</v-btn
                                >
                                <v-btn
                                    color="success"
                                    large
                                    @click="saveTotalFacturado(3)"
                                    >Modificar</v-btn
                                >
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_importar" max-width="1000px">
            <import_stepper
                @saveFacturado="saveFacturado"
                @refresh="getCuentasController()"
                @close="
                    () => {
                        getCuentasController();
                        dialog_importar = false;
                    }
                "
                v-model="step"
                :id_empresa="empresa_controller"
            ></import_stepper>
        </v-dialog>
        <v-dialog v-model="dialog_mod_cuenta" max-width="700px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Modificar cuenta contable
                </v-card-title>
                <v-row class="pa-3">
                    <v-col cols="12" md="6">
                        <v-text-field
                            outlined
                            v-model="mod_cuenta.cuenta_contable"
                            label="C. Contable"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            outlined
                            v-model="mod_cuenta.partida"
                            label="Partida"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="pa-3">
                    <v-col cols="12" md="6">
                        <v-text-field
                            outlined
                            v-model="mod_cuenta.nombre"
                            label="Método NMC1"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            outlined
                            v-model="mod_cuenta.apellido"
                            label="Método NMC2"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="dialog_mod_cuenta = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="modificar_cuenta"
                        >Modificar</v-btn
                    >
                    <v-btn color="error" large @click="eliminar_cuenta"
                        >Eliminar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <loader v-if="isloadingM"></loader>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

import FilterComponent from "../../../components/general/FilterComponent.vue";
import Speedometer from "./Speedometer.vue";
import LineChart from "../componentes/line.vue";
import import_stepper from "./import_stepper.vue";
export default {
    data() {
        return {
            anio: new Date().getFullYear(),
            series_epc: [],
            historial_cuentas: [],
            historial_headers: [
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Beneficio", value: "beneficio", sortable: false },
                { text: "Porcentaje", value: "porcentaje", sortable: false },
                {
                    text: "Total facturado",
                    value: "total_facturado",
                    sortable: false,
                },
                { text: "Estructura", value: "estructura", sortable: false },
                {
                    text: "Resto estructura",
                    value: "resto_estructura",
                    sortable: false,
                },
                {
                    text: "Cashflow a fecha",
                    value: "diferencia_banco",
                    sortable: false,
                },
                {
                    text: "Porcentaje",
                    value: "porcentaje_banco",
                    sortable: false,
                },
            ],
            step: 1,
            chartOptions2: {
                chart: {
                    id: "estadistica",
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return this.formatNumber(value) + "%";
                        },
                    },
                },
                xaxis: {
                    categories: [
                        "Enero",
                        "Febrero",
                        "Marzo",
                        "Abril",
                        "Mayo",
                        "Junio",
                        "Julio",
                        "Agosto",
                        "Septiembre",
                        "Octubre",
                        "Noviembre",
                        "Diciembre",
                    ],
                },
            },
            chartOptions: {
                chart: {
                    id: "estadistica",
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return this.formatNumber(value) + "€";
                        },
                    },
                },
                xaxis: {
                    categories: [
                        "Enero",
                        "Febrero",
                        "Marzo",
                        "Abril",
                        "Mayo",
                        "Junio",
                        "Julio",
                        "Agosto",
                        "Septiembre",
                        "Octubre",
                        "Noviembre",
                        "Diciembre",
                    ],
                },
            },
            series: [
                {
                    name: "Total facturado",
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                },
                {
                    name: "Total beneficio",
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                },
            ],
            empresa_controller: 1,
            empresas_controller: [
                {
                    id: 1,
                    nombre: "ELECTROTECNIA INELCO, S.L",
                },
                {
                    id: 5,
                    nombre: "CDK",
                },
            ],
            percent: 75,
            filtros_prueba: {
                search: "",
                nombre: {},
                apellido: {},
            },
            filter_headers: [
                {
                    title: "Método NMC1",
                    type: "select",
                    active: false,
                    model: "nombre",
                    item_text: "nombre",

                    item_value: "id",
                },
                {
                    title: "Método NMC2",
                    type: "select",
                    active: false,
                    model: "apellido",
                    item_text: "nombre",

                    item_value: "id",
                },
            ],
            total_alcanzado: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_objetivo: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_presupuesto: {
                id_empresa: 0,
                year: 0,
                epc: 0,
                recp: 0,
            },
            total_alcanzadoCdk: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_objetivoCdk: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_presupuestoCdk: {
                id_empresa: 0,
                year: 0,
                epc: 0,
                recp: 0,
            },
            total_alcanzadoVallas: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_objetivoVallas: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_presupuestoVallas: {
                id_empresa: 0,
                year: 0,
                epc: 0,
                recp: 0,
            },
            total_alcanzadoTro: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_objetivoTro: {
                id_empresa: 0,
                year: 0,
                total_facturado: 0,
                total_vendido: 0,
            },
            total_presupuestoTro: {
                id_empresa: 0,
                year: 0,
                epc: 0,
                recp: 0,
            },
            dialog_total_facturado: false,
            isloading: false,
            search: "",
            tab: 0,
            mod_cuenta: {
                id: "",
                apellido: "",
                nombre: "",
                partida: "",
                cuenta_contable: "",
            },
            dialog_mod_cuenta: false,
            file: null,
            year: null,
            opcion_totales: null,
            dialog_importar: false,

            headers_resumen: [
                {
                    title: "Nombre",
                    value: "nombre",
                },
                {
                    title: "Cantidad",
                    value: "total_sum",
                },
                {
                    title: "Porcentaje",
                    value: "porcentaje",
                },
            ],
            resumen_total: [],
            resumen_total_cdk: [],
            resumen_total_vallas: [],
            resumen_total_tro: [],
            resumen_pr: [],
            resumenSobreCoste: [],
            resumen_tro: [],
            resumen_es: [],
            options: {},
            sorted: true,
            all_selected: false,
            selected: [],
            search: "",
            page: 1,
            loading: false,
            busqueda: "buscar",
            cuentasControllerFiltered: [],

            CuentaController: {},
            totales: [],
            cuentasController: [],
            selectedItem: 0,
            dialog: false,
            isMobile: false,

            savedSortBy: null,
            savedSortDesc: null,
            total_resumen: {
                beneficio: 0,
                porcentaje: 0,
                porcentajeVenta: 0,
                porcentajeFacturacion: 0,
            },
            totales_configuracion: {
                objetivos: {},
                alcanzado: {},
                presupuesto: {},
            },
        };
    },
    mounted() {
        this.checkMobileView();
        // Listen for window resize events
        window.addEventListener("resize", this.checkMobileView);
    },
    beforeDestroy() {
        // Remove the resize event listener when the component is destroyed
        window.removeEventListener("resize", this.checkMobileView);
    },

    created() {
        this.getMetodos();
        //this.getEmpresas();
        this.getCuentasController();
    },
    watch: {
        anio: function (val) {
            this.getCuentasController();
        },
        filtros_prueba: {
            deep: true,
            handler: debounce(function (val) {
                //console.log(val);
                //console.log(this.cuentasControllerFiltered);

                this.search = val.search;
                this.filterCalculos();
            }, 500),
        },
        empresa_controller: function (val) {
            this.getCuentasController();
        },
    },
    methods: {
        ExportExcel() {
            let ids = [];

            axios
                .post(
                    "/api/export-cuentas-contables",
                    { cuentas: this.cuentasControllerFiltered },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
            /*axios
                .get(
                    `/api/export-cuentas-contables?cuentas=${this.cuentasControllerFiltered}`,
                    { responseType: "blob" }
                )
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "cuentas controller.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });*/
        },
        downloadFile(response) {
            let blob = new Blob([response.data], { type: "xlsx" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        },
        formatNumber(num) {
            // First, convert the number to the standard format with comma as thousand separator
            num = parseFloat(num).toFixed(2);

            let parts = num.toString().split(".");

            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            if (parts[1]) {
                parts[1] = parts[1].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                parts[1] = "00";
            }

            return parts.join(",");
        },
        saveFacturado(val) {
            this.total_alcanzado.total_facturado = val.total_facturado;
            this.total_alcanzado.total_vendido = val.total_ventas;
            this.saveTotalFacturado(1);
            this.step = 3;
        },
        getEmpresas() {
            axios.get(`api/get-sociedades`).then((res) => {
                this.empresas_controller = res.data;
            });
        },
        colorRow(item) {
            if (item.nombre == "BENEFICIO") {
                let cantidad = item.total_sum.replace(".", "");
                cantidad = cantidad.replace(",", ".");
                if (cantidad > 0) {
                    return "verde";
                } else {
                    return "rojo";
                }
            }
        },
        filterCalculos() {
            this.cuentasControllerFiltered = this.cuentasController.filter(
                (elemento) => {
                    //console.log(this.filtros_prueba.nombre);
                    var condition = true;

                    if (this.filtros_prueba.nombre != '') {
                        if (
                            this.filtros_prueba.nombre.nombre != null &&
                            this.filtros_prueba.nombre.nombre != ""
                        ) {
                            if (elemento["nombre.nombre"]) {
                                condition = ( 
                                    elemento["nombre.nombre"] ==
                                    this.filtros_prueba.nombre.nombre
                                );
                            }
                            else{
                                condition  = false;
                            }
                            
                        }
                    }else{
                        //console.log(elemento["nombre.nombre"]);
                        condition = elemento["nombre.nombre"]!='NA';
                    }
                    if (this.filtros_prueba.apellido != '') {
                        if (
                            this.filtros_prueba.apellido.nombre != null &&
                            this.filtros_prueba.apellido.nombre != ""
                        ) {
                            if (elemento["apellido.nombre"]) {
                                condition = condition & (
                                    elemento["apellido.nombre"] ==
                                    this.filtros_prueba.apellido.nombre
                                );
                            }else{
                                condition  = false;
                            }
                        }
                    }
                    else{
                        condition = condition &  elemento["apellido.nombre"]!='NA';
                    }
                    if (this.search != null && this.search != "") {
                        condition = condition & (
                            elemento["anterior"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["apellido.nombre"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["nombre.nombre"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["numero"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["partida"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["porcentaje"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["total"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["total1"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            elemento["total2"]
                                .toLowerCase()
                                .includes(this.search.toLowerCase())
                        );
                    }
                    return condition;
                }
            );
        },
        getMetodos() {
            axios.get("api/get-cuenta-metodos").then(
                (res) => {
                    this.filter_headers[0].items = res.data.metodos_nombre;
                    this.filter_headers[1].items = res.data.metodos_apellido;
                },
                (err) => {
                    this.$toast.error("Error obteniendo los métodos");
                }
            );
        },
        exportarCuentasContables() {
            axios.get("api/export-cuentas-contables").then(
                (res) => {
                    this.$toast.error(
                        "Cuentas contables descargadas con éxito"
                    );
                },
                (err) => {
                    this.$toast.error("Error descargando las cuentas contables");
                }
            );
        },
        saveTotalFacturado(empresa) {
            //console.log("empresaaaaa");
            //console.log(empresa);
            switch (empresa) {
                case 1:
                    this.totales_configuracion.objetivos = this.total_objetivo;
                    this.totales_configuracion.alcanzado = this.total_alcanzado;
                    this.totales_configuracion.presupuesto =
                        this.total_presupuesto;
                    break;
                case 2:
                    this.totales_configuracion.objetivos =
                        this.total_objetivoCdk;
                    this.totales_configuracion.alcanzado =
                        this.total_alcanzadoCdk;
                    this.totales_configuracion.presupuesto =
                        this.total_presupuestoCdk;
                    break;
                case 3:
                    this.totales_configuracion.objetivos =
                        this.total_objetivoVallas;
                    this.totales_configuracion.alcanzado =
                        this.total_alcanzadoVallas;
                    this.totales_configuracion.presupuesto =
                        this.total_presupuestoVallas;
                    break;
                case 4:
                    this.totales_configuracion.objetivos =
                        this.total_objetivoTro;
                    this.totales_configuracion.alcanzado =
                        this.total_alcanzadoTro;
                    this.totales_configuracion.presupuesto =
                        this.total_presupuestoTro;
                    break;

                default:
                    break;
            }
            this.totales_configuracion.year = this.anio;
            axios
                .post("api/save-total-facturado", this.totales_configuracion)
                .then(
                    (res) => {
                        this.getCuentasController();
                        this.dialog_total_facturado = false;
                    },
                    (err) => {
                        this.$toast.error(
                            "Error al actualizar la configuración"
                        );
                    }
                );
        },
        mostrarModalTotalFacturado() {
            this.dialog_total_facturado = true;
        },
        mostrarModalImportar() {
            this.dialog_importar = true;
            this.step = 1;
        },
        eliminar_cuenta() {
            axios.post("api/eliminar-cuenta", this.mod_cuenta).then(
                (res) => {
                    this.getCuentasController();
                    this.dialog_mod_cuenta = false;
                },
                (err) => {
                    this.$toast.error("Error al eliminar la cuenta contable");
                }
            );
        },
        modificar_cuenta() {
            //console.log(this.mod_cuenta);
            axios.post("api/modificar-cuenta", this.mod_cuenta).then(
                (res) => {
                    this.getCuentasController();
                    this.dialog_mod_cuenta = false;
                },
                (err) => {
                    this.$toast.error("Error al actualizar la cuenta contable");
                }
            );
        },

        checkMobileView() {
            this.isMobile = window.innerWidth <= 768; // Set the breakpoint value as per your needs
        },

        handleClick(value) {
            this.mod_cuenta.id = this.empresa_controller;
            this.mod_cuenta.cuenta_contable = value.numero;
            this.mod_cuenta.partida = value.partida;
            this.mod_cuenta.nombre = value["nombre.nombre"];
            this.mod_cuenta.apellido = value["apellido.nombre"];
            this.dialog_mod_cuenta = true;
        },

        getRowClass(item) {
            return "pointer";
        },

        getCuentasController() {
            this.isloading = true;
            let filtros = this.filterString;

            if (this.empresa_controller == 1) {
                axios
                    .get(
                        `api/get-cuentas-controller/${this.empresa_controller}?year=${this.anio}`
                    )
                    .then(
                        (res) => {
                            this.cuentasController = res.data.cuentas;
                            this.filterCalculos();
                            this.totales = res.data.totales;
                            this.resumen_es = res.data.resumenEs;
                            this.resumen_pr = res.data.resumenPr;
                            this.resumen_tro = res.data.resumenTro;
                            this.resumenSobreCoste = res.data.resumenSobreCoste;
                            this.resumen_total = res.data.resumenTotal;
                            this.resumen_total_vallas =
                                res.data.resumenTotalVallas;
                            this.resumen_total_cdk = res.data.resumenTotalCdk;
                            this.resumen_total_tro = res.data.resumenTotalTro;
                            this.total_alcanzado = res.data.totalAlcanzado;
                            this.total_objetivo = res.data.totalObjetivo;
                            this.total_presupuesto = res.data.totalPresupuesto;
                            ///
                            this.total_alcanzadoTro =
                                res.data.totalAlcanzadoTro;
                            this.total_objetivoTro = res.data.totalObjetivoTro;
                            this.total_presupuestoTro =
                                res.data.totalPresupuestoTro;
                            ///
                            this.total_alcanzadoCdk =
                                res.data.totalAlcanzadoCdk;
                            this.total_objetivoCdk = res.data.totalObjetivoCdk;
                            this.total_presupuestoCdk =
                                res.data.totalPresupuestoCdk;
                            ///
                            this.total_alcanzadoVallas =
                                res.data.totalAlcanzadoVallas;
                            this.total_objetivoVallas =
                                res.data.totalObjetivoVallas;
                            this.total_presupuestoVallas =
                                res.data.totalPresupuestoVallas;
                            this.total_resumen = res.data.totalResumen;

                            //obtenemos estadísticas historial
                            this.series = [
                                {
                                    name: "Total facturado",
                                    data: res.data.mesesTotalFacturado,
                                },
                                {
                                    name: "Total vendido",
                                    data: res.data.mesesTotalVendido,
                                },
                                {
                                    name: "Total objetivo facturado",
                                    data: res.data.mesesTotalObjetivoFacturado,
                                },
                                {
                                    name: "Total objetivo vendido",
                                    data: res.data.mesesTotalObjetivoVendido,
                                },
                                /*{
                                    name: "Total Epc",
                                    data: res.data.mesesTotalEpc,
                                },
                                {
                                    name: "Total Recp",
                                    data: res.data.mesesTotalRecp,
                                },*/
                            ];
                            this.series_epc = [
                                /* {
                                    name: "Total Objetivo Es",
                                    data: res.data.mesesTotalObjetivoEpc,
                                },*/
                                {
                                    name: "Total Es",
                                    data: res.data.mesesTotalEpc,
                                },
                                /*{
                                    name: "Total Objetivo Repc",
                                    data: res.data.mesesTotalObjetivoRecp,
                                },*/

                                {
                                    name: "Total Recp",
                                    data: res.data.mesesTotalRecp,
                                },
                            ];
                            this.historial_cuentas = res.data.historial;
                            this.isloading = false;
                        },
                        (err) => {
                            this.$custom_error("Error consultando las cuentas");
                            this.isloading = false;
                        }
                    );
            } else {
                axios
                    .get(
                        `api/get-cuentas-controller/${this.empresa_controller}`
                    )
                    .then(
                        (res) => {
                            this.cuentasController = res.data.cuentas;
                            this.filterCalculos();
                            this.totales = res.data.totales;
                            this.resumen_es = res.data.resumenEs;
                            this.resumen_pr = res.data.resumenPr;
                            this.resumenSobreCoste = res.data.resumenSobreCoste;
                            this.resumen_total = res.data.resumenTotal;

                            this.total_alcanzado = res.data.totalAlcanzado;
                            this.total_objetivo = res.data.totalObjetivo;
                            this.total_presupuesto = res.data.totalPresupuesto;

                            this.total_resumen = res.data.totalResumen;

                            this.series = [
                                {
                                    name: "Total facturado",
                                    data: res.data.mesesTotalFacturado,
                                },
                                {
                                    name: "Total vendido",
                                    data: res.data.mesesTotalVendido,
                                },
                                {
                                    name: "Total objetivo facturado",
                                    data: res.data.mesesTotalObjetivoFacturado,
                                },
                                {
                                    name: "Total objetivo vendido",
                                    data: res.data.mesesTotalObjetivoVendido,
                                },
                                /*{
                                    name: "Total Epc",
                                    data: res.data.mesesTotalEpc,
                                },
                                {
                                    name: "Total Recp",
                                    data: res.data.mesesTotalRecp,
                                },*/
                            ];

                            this.series_epc = [
                                {
                                    name: "Total objetivo Es",
                                    data: res.data.mesesTotalObjetivoEpc,
                                },
                                {
                                    name: "Total Es",
                                    data: res.data.mesesTotalEpc,
                                },
                                {
                                    name: "Total objetivo Repc",
                                    data: res.data.mesesTotalObjetivoRecp,
                                },

                                {
                                    name: "Total Recp",
                                    data: res.data.mesesTotalRecp,
                                },
                            ];
                            this.historial_cuentas = res.data.historial;

                            this.isloading = false;
                        },
                        (err) => {
                            this.$custom_error("Error consultando las cuentas");
                            this.isloading = false;
                        }
                    );
            }
            /*this.isloading = true;
            let filtros = this.filterString;

            axios
                .get(`api/get-cuentas-controller/${this.empresa_controller}`)
                .then(
                    (res) => {
                        this.cuentasController = res.data.cuentas;
                        this.filterCalculos();
                        this.totales = res.data.totales;
                        this.resumen_es = res.data.resumenEs;
                        this.resumen_pr = res.data.resumenPr;
                        this.resumenSobreCoste = res.data.resumenSobreCoste;
                        this.resumen_total = res.data.resumenTotal;

                        this.total_alcanzado = res.data.totalAlcanzado;
                        this.total_objetivo = res.data.totalObjetivo;
                        this.total_presupuesto = res.data.totalPresupuesto;

                        this.total_resumen = res.data.totalResumen;
                        this.historial_cuentas = res.data.historial;
                        this.series = [
                            {
                                name: "Total Facturado",
                                data: res.data.mesesTotalFacturado,
                            },
                            {
                                name: "Total Beneficio",
                                data: res.data.mesesTotalBeneficio,
                            },
                            {
                                name: "Total Objetivo Facturación",
                                data: res.data.mesesTotalObjetivoFacturado,
                            },
                            {
                                name: "Total Objetivo Ventas",
                                data: res.data.mesesTotalObjetivoVendido,
                            },
                        ];
                        this.series_epc = [
                            {
                                name: "Total Objetivo Es",
                                data: res.data.mesesTotalObjetivoEpc,
                            },
                            {
                                name: "Total Es",
                                data: res.data.mesesTotalEpc,
                            },
                            {
                                name: "Total Objetivo Repc",
                                data: res.data.mesesTotalObjetivoRecp,
                            },

                            {
                                name: "Total Recp",
                                data: res.data.mesesTotalRecp,
                            },
                        ];

                        this.isloading = false;
                    },
                    (err) => {
                        this.$custom_error("Error consultando Cuentas");
                        this.isloading = false;
                    }
                );*/
        },

        openModal(item) {
            this.selectedItem = this.Clientes.indexOf(item);
            this.dialog = true;
        },
    },
    filters: {},
    components: {
        FilterComponent,
        Speedometer,
        LineChart,
        import_stepper,
    },
    computed: {
        isloadingM: function () {
            return this.$store.getters.getloading;
        },
        anios() {
            const currentYear = new Date().getFullYear();
            const startYear = 2023;
            const years = [];

            for (let year = startYear; year <= currentYear; year++) {
                years.push(year);
            }

            return years;
        },
        rol() {
            return localStorage.getItem("role");
        },
        headers() {
            return [
                { text: "C. Contable", value: "numero", sortable: false },
                { text: "Partida", value: "partida", sortable: false },
                { text: "Año anterior", value: "anterior", sortable: false },
                {
                    text: `Método NMC1`,
                    value: "nombre.nombre",
                    sortable: false,
                },
                {
                    text: `Método NMC2`,
                    value: "apellido.nombre",
                    sortable: false,
                },
                { text: "Total 1", value: "total1", sortable: true },
                { text: "Total 2", value: "total2", sortable: true },
                { text: "Total", value: "total", sortable: true },
                { text: "Porcentaje", value: "porcentaje", sortable: false },
            ];
        },
    },
};
</script>
<style>
.verde {
    background-color: green;
    color: white;
}
.rojo {
    background-color: red;
    color: white;
}
</style>
